import React from 'react'
import classnames from 'classnames'
import styles from './styles.css'

export interface MessageBubbleProps extends React.HTMLAttributes<HTMLSpanElement> {}

const MessageBubble: React.SFC<MessageBubbleProps> = ({ className, ...rest }) => {
  const classes = classnames(className, styles['message-bubble'])

  return <span className={classes} {...rest} />
}

export default MessageBubble
